import React, { useEffect } from 'react';
import imgSneakPetShop from '../../../assets/PetShop-Folders-Items-Partial.webp'
import LandJoinForm from '../LandJoinForm';
import HoverAreaItem from '../HoverAreaItem';
import './Land2.css';

const Land2 = () => {  
  
  useEffect(() => {
    document.title = 'Kiponos.io - Real-Time Config Management';
  }, []);

  return (
    <div className='land2'>
      <div className='land2Header'>
        <div className='land2Logo'>Ƙiponos</div>
        <div className='land2LinkBar'>
          <HoverAreaItem title={'Features'}>
            <div>WebSocket based Java SDK</div>
            <div>WebSocket based Web Admin</div>
            <div>SpringBoot Compatible</div>            
          </HoverAreaItem>

          <HoverAreaItem title={'Pricing'}>
            <div>View our pricing plans</div>
            <div>Free Forever for Single Team</div>
            <div>Affordable Multi Team Project Plan</div>
          </HoverAreaItem>

          <HoverAreaItem title={'Docs'}>
            <div>Access our documentation</div>
            <div>SDK Usage and Examples</div>
            <div>API Reference</div>
          </HoverAreaItem>

          <HoverAreaItem title={'Support'}>
            <div>Contact our support team</div>
            <div>Report issues and feedback</div>
          </HoverAreaItem>

        </div>
        <div className='land2Actions'>
          <div>
            <a className='land2ActionLink' href='https://kiponos.io/login' target='_blank' rel='noopener noreferrer'>Login</a>            
          </div>
        </div>
      </div>

      <div className='land2MainTitle'>
        <div className='land2Hero'>        
          Real-Time Config Management
        </div>

        <div className='land2Features'>
          <div className='land2Feature'>Instant Config Updates</div>
          <div className='land2Feature'>No Restarts, No Reloads</div>
        </div>

        <div className='signMeUp'>
          <LandJoinForm withTags={false} cta='Start Free Team Plan'/>
        </div>

        <div className='land2Features'>
          <div className='land2Feature'>WebSocket Based</div>
          <div className='land2Feature'>Highly Encrypted</div>
          <div className='land2Feature'>Role Based Access Per Team</div>
          <div className='land2Feature'>Free Forever for Single Team</div>
        </div>


        <div className='land2DescStart'>Anything you change online...</div>

        {/* <div>Your Team Deserve That Productivity, Efficiency, And Money Savings Boost!</div>
        <div>Stop spending money on configuration chaos</div>
        <div>
          No More Restarts! No More Reloads! Not Even a Refresh!
          Your Application React Instantly!
        </div>         */}
      </div>

      <div className='land2SneakPeakWrap'>
        <img className='land2SneakPeak' src={imgSneakPetShop} alt='Kiponos Config Sample - PetShotServer' />
      </div>

      <div className='land2DescEnd'>... instantly affecting your server! </div>

      <div className='land2Features'>
          <div className='land2Feature'>Multi Env, Multi Profiles</div>          
          <div className='land2Feature'>Users in multi teams</div>          
        </div>

      <div className='signMeUp'>
        <LandJoinForm withTags={false} cta='Start Free Team Plan'/>
      </div>

      <div className='land2Footer'>SSL | WSS | Highly Encrypted Vault | Role Per Team Access Control</div>
    </div>
  );
};

export default Land2;